export default __webpack_public_path__ + "static/media/defProduct.f14a443e.webp";